module.exports = __webpack_public_path__ + "img/图片13.5200c3c3.png";